<div class="flex-c position-relative" style="max-width: 150px">
  <input
    type="button"
    class="color-view border-none"
    [style.background-color]="color"
    cpPosition="bottom"
    cpPositionOffset="50%"
    cpAlphaChannel="disabled"
    [(colorPicker)]="color"
    (colorPickerChange)="onColorChange()"
    readonly />
  <div class="color-form">
    <div class="color-label">{{ title }}</div>
    <div class="input-simple align-self-stretch">
      <input
        type="text"
        class="input-field"
        placeholder="#000000"
        [(ngModel)]="color"
        (ngModelChange)="onColorChange()" />
    </div>
  </div>
</div>
